import { atom, onConnect, reatomAsync } from "@reatom/framework";
import { getCity } from "../../../api/requests/getCity";
import { getCountry } from "../../../api/requests/getCountry";
import { CityInterface, CountryInterface } from "./types";

export const citiesAtom = atom<CityInterface[]>([], "citiesAtom");
export const countriesAtom = atom<CountryInterface[]>([], "countriesAtom");

export const getCityAction = reatomAsync(
  async (ctx, id: number) => ctx.schedule(() => getCity(id)),
  {
    name: "getCityAction",
    onFulfill: (_ctx, data) => {
      citiesAtom(_ctx, data);
    },
    onReject: (_ctx, error) => {
      console.error(error);
    },
  }
);

export const getCountryAction = reatomAsync(
  async (ctx) => ctx.schedule(getCountry),
  {
    name: "getCountryAction",
    onFulfill: (_ctx, data) => {
      countriesAtom(_ctx, data);
    },
    onReject: (_ctx, error) => {
      console.error(error);
    },
  }
);

onConnect(countriesAtom, getCountryAction);
